import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import Booked4us from '../icons/Booked4us';
import config from 'src/constants';
import { getSimplePayPaymentInformationUrl } from 'src/services/api/paymentReservation';

const messages = defineMessages({
    getBooked4Us: {
        id: 'getBooked4Us',
        defaultMessage: 'Tetszik a foglalási rendszerünk? Indítsd el saját időpontfoglaló naptáradat!'
    }
});

interface IFooterProps {
    isEmbedded: boolean;
    hasActiveBarionPocket: boolean;
    hasActiveSimplePayPocket: boolean;
}

const Footer: React.FunctionComponent<IFooterProps> = ({ isEmbedded, hasActiveBarionPocket, hasActiveSimplePayPocket }) => {
    const intl = useIntl();

    return (
        <>
            {hasActiveBarionPocket &&
                <div className='payment-logo'>
                    <img className='payment-logo__image'
                        alt='Barion Bankcard Logos Footer'
                        src={'https://b4us-content-common.s3.eu-central-1.amazonaws.com/img/logos/barion-banner-lightmode.svg'}
                    />
                </div>
            }
            {hasActiveSimplePayPocket &&
                <div className='payment-logo'>
                    <a href={getSimplePayPaymentInformationUrl(intl.locale)} target="_blank" rel="noreferrer" >
                        <img alt='SimplePay Bankcard Logos Footer'
                            className='payment-logo__image'
                            src='https://b4us-content-common.s3.eu-central-1.amazonaws.com/img/logos/simplepay_bankcard_logos_left_482x40_new.png' />
                    </a>
                </div>
            }
            <footer className={`footer ${isEmbedded ? 'footer--embedded' : ''}`}>
                <div className="footer__logo">
                    <Booked4us />
                </div>
                <a href={'https://' + config.MAIN_PAGE_URL} className="link">
                    <FormattedMessage {...messages.getBooked4Us} />
                </a>
            </footer>
        </>
    );
}
export default Footer;